export default __webpack_public_path__ + "static/media/discount-bg.8d91b650.svg";